module.exports = __webpack_public_path__ + "static/img/200097.353699e1.png";